export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-30" style={{
          background: 'radial-gradient(ellipse 60% 50% at 80% 50%, oklch(0.48 0.22 25 / 0.35), transparent 70%), radial-gradient(ellipse 40% 40% at 20% 20%, oklch(0.68 0.18 85 / 0.15), transparent 60%)',
        }}></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-xs md:text-sm mb-5 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              24小时滚动更新 · 一手黑料速递
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-100 leading-tight mb-4">
              暗网吃瓜
              <span className="text-primary-400"> · 全网最真实吃瓜爆料社区</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-300 font-heading mb-6">
              暗网吃瓜论坛 &amp; 吃瓜群 · 黑料讨论不夜城
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              暗网吃瓜是国内最活跃的暗网吃瓜论坛与吃瓜群聚合平台，每天汇集全网最新黑料讨论和爆料交流。无论你是想第一时间围观真实吃瓜事件，还是挖掘隐秘八卦背后的真相，这里都有最野的吃瓜速递和最深的新爆料线索。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              社区保持高频更新，热门话题从娱乐圈到互联网大厂，覆盖全网最劲爆的新爆料内容，让你永远走在吃瓜第一线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">8500+</div>
                <div className="text-xs text-foreground-500 mt-1">每日新帖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">320万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">7×24h</div>
                <div className="text-xs text-foreground-500 mt-1">不间断更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                立即围观热门爆料
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-200 hover:bg-background-300 text-foreground-300 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                我要爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20digital%20art%20with%20crimson%20red%20glowing%20accents%2C%20encrypted%20data%20streams%2C%20hidden%20secrets%20aesthetic%2C%20cyberpunk%20information%20network%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20modern%20tech%20noir%20style%2C%20glitch%20effects%20on%20edges%2C%20eye%20symbol%20subtle%20motif%2C%20warm%20amber%20and%20red%20highlights%20on%20dark%20background%2C%20editorial%20quality%20composition&width=840&height=840&seq=hero-main-visual&orientation=squarish"
                alt="暗网吃瓜 - 隐秘信息与爆料网络"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-background-50/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}